import { OrgNoteDialog } from "@/components/org-note/org-note-dialog";
import { OrgNotePopover } from "@/components/org-note/org-note-popover";
import { useOrgNoteDraft } from "@/components/org-note/use-org-note-draft";

interface OrgNoteEditorProps {
  orgNote: string | null;
  canEdit: boolean;
  popover?: boolean;
  // Unique per row so the dialog's label targets its own textarea.
  inputId: string;
  // Controlled so the caller can close the editor once its save succeeds.
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isSaving: boolean;
  onSave: (orgNote: string | null) => void;
}

/**
 * Internal business-unit note on an org review row (time entries, expenses),
 * hidden from the provider. Renders as a compact popover or as inline text
 * with an edit dialog.
 */
export function OrgNoteEditor({
  orgNote,
  canEdit,
  popover = false,
  inputId,
  open,
  onOpenChange,
  isSaving,
  onSave,
}: OrgNoteEditorProps) {
  const draft = useOrgNoteDraft({ orgNote, onOpenChange, onSave });

  if (!canEdit && !orgNote) {
    return null;
  }

  if (popover) {
    return (
      <OrgNotePopover
        orgNote={orgNote}
        canEdit={canEdit}
        open={open}
        isSaving={isSaving}
        draft={draft}
      />
    );
  }

  return (
    <OrgNoteDialog
      orgNote={orgNote}
      canEdit={canEdit}
      inputId={inputId}
      open={open}
      isSaving={isSaving}
      draft={draft}
    />
  );
}
